'use client'

import React, { createContext, use, useEffect, useState } from 'react'

import type { SubBrand, SubBrandContextType } from './types'

const initialContext: SubBrandContextType = {
  subBrand: 'civo',
}

const SubBrandContext = createContext(initialContext)

export const SubBrandProvider = ({ 
  children
}: { 
  children: React.ReactNode
}) => {
  const [subBrand, setSubBrand] = useState<SubBrand>('civo')

  useEffect(() => {
    // Apply the sub brand to the document element
    document.documentElement.setAttribute('data-sub-brand', subBrand)
  }, [subBrand])

  return (
    <SubBrandContext.Provider value={{ subBrand, setSubBrand }}>
      {children}
    </SubBrandContext.Provider>
  )
}

export const useSubBrand = (): SubBrandContextType => use(SubBrandContext)